import { DEMO_SHOWCASE, type DemoShowcase } from '@/config/demoShowcase';
import { useIsDemoRoute } from '@/hooks/useTenantPath';

/**
 * The sales-showcase copy for the /demo site, or null on every real tenant
 * site. Components use it in place of their built-in default copy only —
 * anything the demo org has saved in its admin still wins.
 */
export function useDemoShowcase(): DemoShowcase | null {
  return useIsDemoRoute() ? DEMO_SHOWCASE : null;
}
